import { IReduxState } from 'types/redux';

export const mqttClientsStateSelector = (state: IReduxState) => state.mqttClients;
